// extracted by mini-css-extract-plugin
export default {"issues":"UserIssuesForm_issues__13p6E","buttons":"UserIssuesForm_buttons__1zJ8l"};